import React from "react"

export default function Hamburger({ active = false, ...props }) {
  return (
    <button
      className={`hamburger flex ml-4 ${active ? "is-active" : ""}`}
      {...props}
    >
      <div className="hamburger-box">
        <div className="hamburger-inner"></div>
      </div>
    </button>
  )
}
